import { render, staticRenderFns } from "./EditColorModal.vue?vue&type=template&id=298fbb62&scoped=true"
import script from "./EditColorModal.vue?vue&type=script&lang=js"
export * from "./EditColorModal.vue?vue&type=script&lang=js"
import style0 from "./EditColorModal.vue?vue&type=style&index=0&id=298fbb62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298fbb62",
  null
  
)

export default component.exports